

































































import { Component, Vue, Prop } from "vue-property-decorator";
import DataCard from "../utility/DataCard.vue";
import Debug from "../utility/Debug.vue";
import { UpdateUserDtoFactory } from "@/lib/utility/updateUserDtoFactory";
import { IAdminUser } from "@/models/user.entity";
import { IAddress, Address } from "@/models/address.entity";

@Component({ components: { Debug, DataCard } })
export default class ThgBillingSelectionItemUserAddressData extends Vue {
  @Prop()
  user!: IAdminUser;

  data = this.user;

  address: IAddress = this.user.address ?? new Address();

  locked = true;

  async confirmEdit() {
    if (!this.data) {
      return;
    }

    const updateUserDto = new UpdateUserDtoFactory().createFromIUser({ ...this.data, address: this.address });
    const updatedUser = await this.user.updateFromDto(updateUserDto);
    if (!updatedUser) return;
    this.user = updatedUser;
    this.user.address = updatedUser.address;
  }
}
